// extracted by mini-css-extract-plugin
module.exports = {"blockContent":"block-content_blockContent__1fK9S"};